import http from "../api";

class CashboxDataService {

    getAllLastMovements() {
        return http({
            'url':'/cashbox/last_movements',
            'method':'GET'
        });
    }

    openCashBox(data) {
        return http({
            'url':'/cashbox',
            'method':'POST',
            'data': data
        });
    }

    closeCashBox(data) {
        return http({
            'url':'/cashbox/close',
            'method':'POST',
            'data': data
        });
    }

    registerCashBoxMovement(data) {
        return http({
            'url':'/cashbox/register_movement',
            'method':'POST',
            'data': data
        });
    }
}

export default new CashboxDataService();